import { useV2 } from '@/contexts/V2Context';
import { cn } from '@/lib/utils';

interface V2ToggleProps {
  variant?: 'light' | 'dark';
}

export function V2Toggle({ variant = 'light' }: V2ToggleProps) {
  const { enabled, toggle } = useV2();

  const base = variant === 'dark'
    ? 'bg-white/20 text-white hover:bg-white/30 border-white/30'
    : 'bg-slate-100 text-slate-700 hover:bg-slate-200 border-slate-200';

  return (
    <button
      onClick={toggle}
      className={cn(
        'inline-flex items-center gap-2 px-2.5 py-1.5 rounded-md text-xs font-semibold border transition-colors',
        base
      )}
      title="Toggle V2 experience"
    >
      <span
        className={cn(
          'inline-flex items-center justify-center w-8 h-4 rounded-full transition-colors',
          enabled ? 'bg-emerald-500' : 'bg-slate-300'
        )}
      >
        <span
          className={cn(
            'w-3 h-3 bg-white rounded-full shadow transition-transform',
            enabled ? 'translate-x-2' : '-translate-x-2'
          )}
        />
      </span>
      V2
    </button>
  );
}
